import { RootState } from '@/store';
import { Store } from 'vuex';

export enum Breakpoints {
  MQ1 = 0,
  MQ2 = 480,
  MQ3 = 768,
  MQ4 = 1024,
  MQ5 = 1280,
  MQ6 = 1440
}

export enum MobileBreakpoints {
  MQ1 = 'MQ1',
  MQ2 = 'MQ2',
  MQ3 = 'MQ3'
}

export enum TabletBreakpoints {
  MQ4 = 'MQ4',
  MQ5 = 'MQ5'
}

export enum MediaQueryType {
  Device = 'DEVICE',
  Image = 'IMAGE'
}

export interface MediaQuery {
  MQ: string;
  query: string;
}

export class MediaQueryManager {
  private store: Store<RootState>;

  constructor(store: Store<RootState>) {
    this.store = store;
    this.initListeners(this.deviceMediaQueries, MediaQueryType.Device);
    this.initListeners(this.imageMediaQueries, MediaQueryType.Image);
    this.initAspectRatioListener();
  }

  private get imageMediaQueries(): MediaQuery[] {
    const mediaQueries: MediaQuery[] = [];

    Object.entries(Breakpoints)
      .filter(([, value]) => !isNaN(Number(value)))
      .forEach(([key, value], index, array) => {
        switch (index) {
          case array.length - 1: {
            mediaQueries.push({
              MQ: key,
              query: `(min-width: ${Number(value) + 1}px)`
            });

            break;
          }
          default: {
            mediaQueries.push({
              MQ: key,
              query: `(min-width: ${Number(value) + 1}px) and (max-width: ${array[index + 1][1]}px)`
            });
          }
        }
      });

    return mediaQueries;
  }

  private get deviceMediaQueries(): MediaQuery[] {
    const mediaQueries: MediaQuery[] = [];

    Object.entries(Breakpoints)
      .filter(([, value]) => !isNaN(Number(value)))
      .forEach(([key, value], index, array) => {
        switch (index) {
          case array.length - 1: {
            mediaQueries.push({
              MQ: key,
              query: `(min-width: ${value}px)`
            });

            break;
          }
          default: {
            mediaQueries.push({
              MQ: key,
              query: `(min-width: ${value}px) and (max-width: ${Number(array[index + 1][1]) - 1}px)`
            });
          }
        }
      });

    return mediaQueries;
  }

  private initAspectRatioListener() {
    const matcher = window.matchMedia('(max-aspect-ratio: 1/1)');
    this.store.dispatch('app/setPortrait', matcher.matches);
    matcher.addListener(event => this.store.dispatch('app/setPortrait', event.matches));
  }

  private initListeners(mediaQueries: MediaQuery[], type: MediaQueryType) {
    mediaQueries.forEach(mediaQuery => {
      const matcher: MediaQueryList = window.matchMedia(mediaQuery.query);

      matcher.addListener(event => {
        if (event.matches) {
          // TODO: find a better way. Temporarily fixes problem with window.outerHeight on device rotate.
          setTimeout(() => this.store.dispatch('app/setMediaQuery', { MQ: mediaQuery.MQ, type }));
        }
      });

      if (matcher.matches) {
        this.store.dispatch('app/setMediaQuery', { MQ: mediaQuery.MQ, type });
      }
    });
  }
}
